export const nullableYupNumberTransformer = (
  value: string,
  originalValue: string
) => (originalValue === '' ? null : value);
